import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take, tap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const authService: AuthService = inject(AuthService);

    return authService.isLoggedIn().pipe(
        take(1),
        tap(isOk => {
            if (!isOk) {
                authService.logout();
            }
        }),
        map(isOk => isOk)
    );
};